import React, { useState } from "react";
import instance from "../../../../axios/instance";
import { getToken } from "../../../../utils/token";
import { useLoaderData } from "react-router-dom";
import calculateAge from "../../../../utils/calculateAge";
import { toast } from "react-toastify";
import Spinner from "../../../../components/spinners/Spinner";

export const patientLoader = async ({ params }) => {
  const token = getToken();
  const res = await instance.post(
    "/doctor/patient/single",
    {
      patientId: params.id,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const doctor = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return { patientInfo: res.data, doctor: doctor.data };
};




const PatientInfoPage = () => {
  const { patientInfo } = useLoaderData();
  const [loading, setLoading] = useState(false);

  console.log("PAT info is ", patientInfo);
  

  const handleResendInvite = async () => {
    try {
      setLoading(true);
      const token = getToken();
      await instance.get(`/doctor/patient/resend-invite/${patientInfo.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("New invite sent");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response
          ? error.response.data.message
          : "An unknown error occurred"
      );
    }
  };

  return (
    <div className="px-7 py-10">
      <div className="bg-[#f4f4f4] py-3 text-center font-medium rounded-md text-base">
        Patient's Basic Information
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-8 border px-5 py-5 rounded-md">
        <div>
          <div className="text-sm !tracking-wide mb-1 uppercase text-[black] font-[600]">
            Fullname
          </div>
          <div className="text-sm">
            {patientInfo.lastname} {patientInfo.middlename}{" "}
            {patientInfo.firstname}
          </div>
        </div>

        <div>
          <div className="text-sm !tracking-wide mb-1 uppercase text-[black] font-[600]">
            Birth Sex
          </div>
          <div className="text-sm">{patientInfo.birth_sex}</div>
        </div>

        <div>
          <div className="text-sm !tracking-wide mb-1 uppercase text-[black] font-[600]">
            Gender
          </div>
          <div className="text-sm">
            {!patientInfo.gender ? "--" : patientInfo.gender}
          </div>
        </div>
        <div>
          <div className="text-sm !tracking-wide mb-1 uppercase text-[black] font-[600]">
            Patient ID
          </div>
          <div className="text-sm">BCRXPT{patientInfo.id}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            D.O.B
          </div>
          <div className="text-sm">
            {!patientInfo.dob ? "--" : patientInfo.dob.split(",")[0]}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Age
          </div>
          <div className="text-sm">
            {!patientInfo.dob ? "--" : calculateAge(patientInfo.dob)}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Nickname
          </div>
          <div className="text-light">
            {!patientInfo.nickname ? "--" : patientInfo.nickname}
          </div>
        </div>

        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Maiden name
          </div>
          <div className="text-light">
            {!patientInfo.maiden_name ? "--" : patientInfo.maiden_name}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Language
          </div>
          <div className="text-light">
            {!patientInfo.language ? "--" : patientInfo.language}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Ethnicity
          </div>
          <div className="text-light">
            {!patientInfo.ethnicity ? "--" : patientInfo.ethnicity}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Race
          </div>
          <div className="text-light">
            {!patientInfo.race ? "--" : patientInfo.race}
          </div>
        </div>

        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Marital Status
          </div>
          <div className="text-light">
            {!patientInfo.marital_status ? "--" : patientInfo.marital_status}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Employment Status
          </div>
          <div className="text-light">
            {!patientInfo.employment_status
              ? "--"
              : patientInfo.employment_status}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Account Status
          </div>
          <div
            className={`${
              patientInfo.account_status === "inactive"
                ? "bg-red-100"
                : "bg-green-100"
            } max-w-[100px] w-full text-sm text-center inline-block capitalize py-[2px] px-2 rounded-md`}
          >
            {patientInfo.account_status}
          </div>
        </div>
        {patientInfo.account_status === "inactive" && (
          <button
            className={`w-fit min-w-[100px] border px-5 py-1 flex justify-center items-center rounded-md border-primary duration-300 hover:bg-primary-light text-black cursor-pointer text-sm disabled:opacity-70 disabled:cursor-not-allowed`}
            onClick={handleResendInvite}
            disabled={loading}
          >
            {loading ? <Spinner /> : "Resend invite"}
          </button>
        )}
      </div>

      <div className="bg-[#f4f4f4] mt-10 py-3 text-center font-medium rounded-md text-base">
        Patient's Medical Information
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-8 border px-5 py-5 rounded-md">
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Drug Allergies
          </div>
          <div className="text-sm">
            {!patientInfo.drug_allergies ? "None" : patientInfo.drug_allergies}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Bloog Group
          </div>
          <div className="text-light">
            {!patientInfo.blood_group ? "--" : patientInfo.blood_group}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Smoking Status
          </div>
          <div className="text-light">
            {!patientInfo.smoking_status ? "--" : patientInfo.smoking_status}
          </div>
        </div>
      </div>

      <div className="bg-[#f4f4f4] mt-10 py-3 text-center font-medium rounded-md text-base">
        Patient's Contact Information
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-8 border px-5 py-5 rounded-md">
        <div>
          <div className="text-sm uppercase text-[black] !tracking-wide mb-1 font-[600]">
            Email
          </div>
          <div className="text-sm lowercase">{patientInfo.email_address}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Cell Phone
          </div>
          <div className="text-sm">{patientInfo.cell_phone}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Work Phone
          </div>
          <div className="text-sm">
            {!patientInfo.work_phone ? "--" : patientInfo.work_phone}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Home Phone
          </div>
          <div className="text-sm">
            {!patientInfo.home_phone ? "--" : patientInfo.home_phone}
          </div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Country
          </div>
          <div className="text-sm">{patientInfo.country}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            State
          </div>
          <div className="text-sm">{patientInfo.state}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            City
          </div>
          <div className="text-sm">{patientInfo.city}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Zipcode
          </div>
          <div className="text-sm">{patientInfo.zipcode}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Address Line 1
          </div>
          <div className="text-sm">{patientInfo.address1}</div>
        </div>
        <div>
          <div className="text-sm uppercase !tracking-wide mb-1 text-[black] font-[600]">
            Address Line 2
          </div>
          <div className="text-sm">
            {!patientInfo.address2 ? "--" : patientInfo.address2}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfoPage;
